export default "__VITE_ASSET__DBwlkpN9__"